<template>
  <div class="live-chat-page text-center">
    <TopMenu
      :title="$t('CONTACT_US.PAGE_LABEL')"
      back-to="/dashboard"
      dark-background/>
    <div class="container-fluid content">
      <div class="row-item-transparent-with-border mt-3 pr-4 pl-4 text-left">
        <h3>{{ $t('SIDEMENU.REPRESENTATIVE_CHAT') }}</h3>
      </div>
    </div>
    <div id="chatra-wrapper" />
    <BottomMenu />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TopMenu from '@/components/Menu/TopMenu';
import BottomMenu from '@/components/Menu/BottomMenu';
import LiveChatHelper from '@/helpers/live-chat-helper';
import config from '@/config';

function initChatra(chatraData) {
  window.ChatraSetup = chatraData.chatraSetup;
  (function (d, w, c) {                        // eslint-disable-line
    w.ChatraID = chatraData.chatraId;          // eslint-disable-line
    const s = d.createElement('script');
    w[c] = w[c] || function () {               // eslint-disable-line
      (w[c].q = w[c].q || []).push(arguments); // eslint-disable-line
    };
    s.async = true;
    s.src = 'https://call.chatra.io/chatra.js';
    if (d.head) d.head.appendChild(s);
  })(document, window, 'Chatra');
}

export default {
  name: 'LiveChat',
  components: {
    TopMenu,
    BottomMenu,
  },
  mixins: [LiveChatHelper],
  computed: {
    ...mapState('contactUs', ['liveChatInitialized']),
    ...mapState('member', ['selectedMember', 'selectedContactInformation']),
  },
  watch: {
    selectedContactInformation: {
      handler(newVal) {
        this.setIntegrationData({
          name:
            `${newVal.firstName ? newVal.firstName : ''
            } ${
              newVal.lastName ? newVal.lastName : ''}`,
          email: newVal.email ? newVal.email : '',
          phone: newVal.phoneNumber ? newVal.phoneNumber : '',
        });
      },
    },
  },
  beforeCreate() {
    if (typeof Chatra !== 'function') {
      initChatra({
        chatraId: config.CHATRA_ID,
        chatraSetup: {
          colors: {
            buttonText: '#fff',
            buttonBg: '#0C2340',
          },
          language: (this.$route.query.lang ? this.$route.query.lang : 'fr'),
          zIndex: 3000,
          // clientId: this.selectedMember.memberGuid,
        },
      });
    }
  },
  created() {
    this.showChatra();
    this.$store.dispatch('member/currentMemberContactInformation');
  },
  beforeRouteLeave(to, from, next) {
    this.hideChatra();
    next(true);
  },
};
</script>

<style scoped lang="scss">
div {
  &.live-chat-page {
    height: 100%;
  }
  &.content {
    padding-top: $top-menu-height;
    padding-bottom: $bottom-menu-height;
    background-color: $base;
    min-height: 100%;
  }
}
</style>
